<template>
  <div class="container">
    <v-header></v-header>
    <h4 class="title">
      <span>&nbsp;&nbsp;筛选条件</span>
    </h4>
    <div class="searchContent">
      <el-row>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="7">申请人姓名：</el-col>
            <el-col :span="17">
               <el-input v-model="applyName" class="input" placeholder="请输入申请人姓名"></el-input>
            </el-col> 
          </el-row>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="6">客户姓名：</el-col>
            <el-col :span="18">
              <el-input v-model="customerName" class="input" placeholder="请输入客户姓名"></el-input> 
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="6">咨询状态：</el-col>
            <el-col :span="18">
              <el-select placeholder="请选择" v-model="getList.consultState">
                  <el-option label="全部" :value="null">全部</el-option>
                  <el-option label="进行中" :value="'CONSULTING'">进行中</el-option>
                  <el-option label="已完成" :value="'FINISHED'">已完成</el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <!-- <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">客户性别：</el-col>
            <el-col :span="14">
              <el-input v-model="getList.customerGender" class="input" placeholder="请输入客户性别"></el-input> 
            </el-col>
          </el-row>
        </el-col> -->
      </el-row>
    </div>
    <div class="searchContent">
      <el-row>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="7">申请人工号：</el-col>
            <el-col :span="17">
              <el-input v-model="applyCode" class="input" placeholder="请输入申请人工号"></el-input> 
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="6">客户性别：</el-col>
            <el-col :span="18">
              <!-- <el-input v-model="sex" class="input" placeholder="请输入客户性别"></el-input>  -->
              <el-select placeholder="请选择" v-model="getList.customerGender" style="width:100%">
                <el-option label="全部" :value="null">全部</el-option>
                <el-option label="男" :value="'M'">男</el-option>
                <el-option label="女" :value="'F'">女</el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="6">消息状态：</el-col>
            <el-col :span="18">
              <el-select placeholder="请选择" v-model="getList.replyState">
                <el-option label="全部" :value="null">全部</el-option>
                <el-option label="待回复" :value="'0'">待回复</el-option>
                <el-option label="已回复" :value="'1'">已回复</el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <!-- <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">证件类型：</el-col>
            <el-col :span="14">
              <el-input v-model="getList.idType" class="input" placeholder="请输入证件类型"></el-input> 
            </el-col>
          </el-row>
        </el-col> -->
        <!-- <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">证件号码：</el-col>
            <el-col :span="14">
              <el-input v-model="getList.idNo" class="input" placeholder="请输入证件号码"></el-input> 
            </el-col>
          </el-row>
        </el-col> -->
        <!-- <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="10">咨询状态：</el-col>
            <el-col :span="14">
              <el-select placeholder="请选择" v-model="getList.consultState">
                  <el-option label="全部" :value="null">全部</el-option>
                  <el-option label="进行中" :value="'1'">进行中</el-option>
                  <el-option label="已完成" :value="'2'">已完成</el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col> -->
      </el-row>
    </div>
    <div class="searchContent">
      <el-row>
        <el-col :span="7" :offset="1">
          <el-row>
            <el-col :span="7">咨询类型：</el-col>
            <el-col :span="17">
              <el-select placeholder="请选择" v-model="getList.consultType" style="width:100%;">
                <el-option label="全部" :value="null">全部</el-option>
                <el-option v-for="consult in consultList" :key="consult.code" :label="consult.label" :value="consult.code"></el-option>
                <!-- <el-option label="核保咨询" :value="'12'">核保咨询</el-option> -->
              </el-select>
            </el-col>
          </el-row>
        </el-col>
          <el-col :span="7" :offset="1">
            <el-row>
              <el-col :span="6">
                时间区间：
              </el-col>
              <el-col :span="17">
                <el-date-picker
                  type="daterange"
                  align="right"
                  unlink-panels
                  :editable="false"
                  :clearable="false"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  @change="dateChange"
                  v-model="dateStart"
                  :picker-options="pickerOptions2"
                >
                </el-date-picker>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2" :offset="3">
            <el-row>
              <el-col :span="5">
                <el-button type="primary" @click="search">筛选</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2">
            <el-row>
              <el-col :span="5">
                <el-button type="primary" @click="reset">重置</el-button>
              </el-col>
            </el-row>
          </el-col>
      </el-row>
    </div>
    <div class="tableClass">
      <h4 class="titleTable">
        <span>&nbsp;&nbsp;咨询列表</span>
      </h4>
        <el-table
          :cell-style="colorStyle"
          :cell-class-name="tableCellClassName"
          ref="multipleTable"
          :data="tableData"
          :total="total"
          tooltip-effect="dark"
          border
          fixed
          style="width: 100%"
          >
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="consultType"
          label="咨询类型"
          width="140">
        </el-table-column>
        <el-table-column
          align="center"
          class-name="change"
          label="咨询编号"
          width="140">
          <template slot-scope="scope">
            <div class="cell"
            @mousedown="down($event)"
            @mouseup="move($event,scope.row)"
            >
              {{ scope.row.consultNo }}
            </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="agentCode"
          label="业务员工号"
          width="140"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="agentName"
          label="业务员姓名"
          width="140"
         >
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="客户姓名"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerGender"
          label="客户性别"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerBirth"
          label="客户生日"
          width="170"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="idType"
          label="证件号类型"
          width="140"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="idNo"
          label="证件号码"
          width="170">
        </el-table-column>
        <el-table-column
          align="center"
          prop="consultState"
          label="咨询状态"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="replyState"
          label="消息状态"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createDate"
          label="咨询创建时间"
          width="170">
        </el-table-column>
        <el-table-column label="操作" align="center" >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next, jumper,total"
        :total="total"
        :page-size="10"
        >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import vHeader from '@/layout/Header.vue'
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  name:'clientConsult',
  data(){
    return {
      getList: {
        applyCode: null,
        applyName: null,
        consultType: null,
        customerName: null,
        customerGender: null,
        customerBirth:null,
        idType: null,
        idNo: null,
        consultState: 'CONSULTING',
        modifyState: null,
        replyState:"0",
        startDate: null,
        endDate: null,
        currentPage: 1,
        pageSize: 10,
      },
      getListCopy:{},
      dateStart:'',//初始化绑定时间
      sex:'',//性别
      applyName:'',
      applyCode:'',
      customerName:'',
      total:0, //页码
      startX:'',
      startY:'',
      tableData:[],
      consultList:[], //咨询类型列表数组
      currentPage:1,
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    }
  },
  methods:{
    //获取列表
    getConsults(){
      let that = this
      // let req = this.$route.params.req
      // let customerName = this.$route.params.customerName
      // let applyName = this.$route.params.agentName
      // let applyCode = this.$route.params.applyCode
      // console.log(req,'req')
      // console.log(customerName,'customerName')
      // console.log(applyName,'applyName')
      // console.log(applyCode,'applyCode')
      // if(req){
      //   this.getList = req
      // }
      // if(customerName){
      //   this.customerName = customerName
      //   this.getList.customerName = customerName
      // }
      // if()
      api.post(url.getConsults, this.getList, function(res) {
        if(res.result.isSuccess){
          that.total = res.data.total
          that.tableData = res.data.data
        }
      });
    },
    //查询
    search(){
      // if(this.sex){
      //   this.sex=='男'?this.getList.customerGender='M':this.sex=='女'?this.getList.customerGender='F':''
      // }else{
      //   this.getList.customerGender = null
      // }
      if(this.applyName){
        this.getList.applyName = this.applyName 
      }else{
        this.getList.applyName = null
      }
      if(this.applyCode){
        this.getList.applyCode = this.applyCode
      }else{
        this.getList.applyCode = null
      }
      if(this.customerName){
        this.getList.customerName = this.customerName
      }else{
        this.getList.customerName = null
      }
      this.currentPage = 1
      this.getList.currentPage = this.currentPage
      this.getListCopy = JSON.parse(JSON.stringify(this.getList))
      // console.log(this.getList,'getListaaaa')
      this.getConsults()
    },
    //重置
    reset(){
      this.applyCode = ''
      this.applyName = ''
      this.consultType = ''
      this.customerName = ''
      this.customerBirth = ''
      this.idType = ''
      this.idNo = ''
      this.sex = ''
      this.getList.consultState = null //咨询状态
      this.getList.replyState= null //消息状态
      this.getList.consultType = null //咨询类型
      this.getList.customerGender = null
      this.dateStart = '',
      this.getList.startDate = null
      this.getList.endDate = null
    },
    //获取咨询类型列表
    getConsultTypes(){
      let req = this.$route.params.req
      let customerName = this.$route.params.customerName
      let applyName = this.$route.params.applyName
      let applyCode = this.$route.params.applyCode
      // console.log(req,'req')
      // console.log(customerName,'customerName')
      // console.log(applyName,'applyName')
      // console.log(applyCode,'applyCode')
      let getList = this.$route.params.getList
      let dateStart = this.$route.params.dateStart
      if(getList){
        this.getList = getList
      }
      if(customerName){
        this.customerName = customerName
        this.getList.customerName = customerName
      }
      if(applyName){
        this.applyName = applyName
        this.getList.applyName = applyName
      }
      if(applyCode){
        this.applyCode = applyCode
        this.getList.applyCode = applyCode
      }
      if(dateStart){
        let startOfMonth = dateStart[0]
        let endOfMonth = dateStart[1]
        this.getList.startDate = new Date(startOfMonth).getTime()
        this.getList.endDate = new Date(endOfMonth).getTime()
        this.dateStart = [new Date(startOfMonth), new Date(endOfMonth)];
      }
      api.post(url.getConsultTypes, {}, res=> {
        if(res.result.isSuccess){
          this.consultList = res.data
          this.getConsults()
        }
      });
    },
    dateChange(value) {
      let startDate = new Date(value[0]);
      let endDate = new Date(value[1]);
      this.getList.startDate = startDate.getTime();
      this.getList.endDate = endDate.getTime();
    },
    initDate() {
      let current = new Date();
      let startOfMonth = this.moment(current)
        .startOf('month')
        .format('YYYY/MM/DD');
      let endOfMonth = this.moment(current)
        .endOf('month')
        .format('YYYY/MM/DD');
      // this.getList.startDate = new Date(startOfMonth).getTime();
      // this.getList.endDate = new Date(endOfMonth).getTime();
      // this.dateStart = [new Date(startOfMonth), new Date(endOfMonth)];
    },
    handleEdit(index, row) {
      window.sessionStorage.setItem('consultNo',encodeURIComponent(JSON.stringify(row.consultNo)))
      this.$router.push({
        name:'ConsultDetail',
        params:{ getNochange:this.getList,getList: this.getListCopy,customerName:this.customerName,applyName:this.applyName,applyCode:this.applyCode,dateStart:this.dateStart }
      })
    },
    //切换页码
    handleCurrentChange(value){
      this.getList.currentPage = value
      this.currentPage = value
      this.getConsults()
    },
    colorStyle(column){
      if(column.columnIndex === 1){
        return "color:#409EFF"
      }
    },
    tableCellClassName({row, column, rowIndex, columnIndex}){//注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index=rowIndex;
      column.index=columnIndex;
    },
    down(event){
      this.startX = event.x
      this.startY = event.y
      // console.log(this.startX,'startX')
    },
    move(event,row){
      // console.log(event.x,'xxx')
      if(Math.abs(event.x-this.startX)>10 || Math.abs(event.y-this.startY)>25||event.button !=0){
        return
      }
      window.sessionStorage.setItem('consultContentId',encodeURIComponent(JSON.stringify(row.consultContentId)))
      window.sessionStorage.setItem('consultNo',encodeURIComponent(JSON.stringify(row.consultNo)))
      this.$router.push({
        name:'ConsultDetail',
        params:{ getNochange:this.getList,getList: this.getListCopy,customerName:this.customerName,applyName:this.applyName,applyCode:this.applyCode,idNo:this.idNo,dateStart:this.dateStart }
      })
    }
  },
  mounted(){
    this.getConsultTypes()
  },
  created(){
    this.initDate()
  },
  components:{
    vHeader,
  }
}
</script>
<style scoped>
.title {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.searchContent >>> .el-row{
  height: 40px;
}
.searchContent >>> .el-input__inner{
  padding: 0 10px;
}
.searchContent{
  padding-top: 20px;
  line-height: 40px;
}
.titleTable{
  background-color: #e0e0e0;
  height: 50px;
  line-height: 50px;
}
.tableClass >>> .el-pagination{
  text-align: right;
}
.container{
  background: #fff;
}
.addColor{
  color:#f00
}
.container >>> .el-table__body .change:hover{
  cursor:pointer;
  text-decoration: underline;
  color: #409EFF;
} 
.container >>> .el-table{
  /* margin: 0 auto;
  width: 99%; 
  width: 100%;*/
} 
</style>


// WEBPACK FOOTER //
// src/pages/client/consult.vue